import { RootState } from '../../../store';

export const getTrainersSelector = (state: RootState) => state.trainers;
export const getLoadingTrainersSelector = (state: RootState) => state.trainers.isLoading;
export const getErrorsTrainersSelector = (state: RootState) => state.trainers.errors;
